import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { Form, Control, Errors, actions } from 'react-redux-form';
import { Row, Col, FormGroup, FormControl, ControlLabel, Button, Checkbox, Radio } from 'react-bootstrap';
import { validators } from '../../../../utils/validators';
import { history } from '../../../../store';
import LayoutContainer from '../../../layout/layout-container/index';
import ErrorMessages from '../../login/error-messages';
import ConfirmPopup from '../../../common/confirm-popup';
import IgniteDataTable from '../../../common/datatable/index';
import UserTitleSelector from '../../../common/form/user/user-title-selector';
import UserFirstNameInput from '../../../common/form/user/user-first-name-input';
import UserLastNameInput from '../../../common/form/user/user-last-name-input';
import DateOfBirthSelector from '../../../common/form/user/date-of-birth-selector';
import ArrowButton from '../../../common/button-arrow';
import { checkPermission } from '../../../common/guards/can';
import { saveUser, updatePermissions, updateUser, deleteUser } from '../../../../actions/users';

class UserDetailsForm extends Component {
  constructor(props) {
    super(props);

    this.state = {
      securityQuestion: ''
    };

    this.outletColumns = [
      {
        prop: 'customer_number', title: 'Customer number', onClick: (cell, row) => {
          history.push(`/admin/outlets/${row.id}/view`);
        }
      },
      { prop: 'name', title: 'Outlet name' },
    ];

    this.outletActions = [
      {
        label: 'DELINK FROM OWNER',
        permissions: {
          action: 'delink',
          subjectClass: 'Outlet'
        },
        callback: (row) => {
          history.push(`/admin/outlets/${row.id}/delink`);
        }
      }
    ];
  }

  updateErrors = (field, value) => {
    this.setState({
      [field]: value
    });
  };

  toggleDeletePopup = () => {
    const { showDeletePopup } = this.state;

    this.setState({
      showDeletePopup: !showDeletePopup
    });
  };

  handleDeletePopup = (result) => {
    const { user, dispatch } = this.props;

    if (result) {
      dispatch(deleteUser(user.id)).then(history.push('/admin/users'));
    }

    this.toggleDeletePopup();
  };

  showSecurityAnswer = () => {
    const { user } = this.props;
    const { securityQuestion } = this.state;

    this.setState({
      securityAnswer: user.relationships['security-answers'].data
        .find(item => item.security_question_id === securityQuestion).answer
    });
  };

  onSubmitUser = (payLoad) => {
    const { dispatch, user: { id }, saveLink } = this.props;

    const attributes = { ...payLoad };

    dispatch(actions.submitFields('deep.admin_user.details',
                                  id ? updateUser(saveLink, attributes) : saveUser(attributes))
    ).then(
        () => {
          dispatch(actions.reset('deep.admin_user.details'));
          history.push('/admin/users');
        }
      );
  };

  onSubmitPermissions = (payLoad) => {
    const { dispatch, user: { id } } = this.props;

    dispatch(actions.submitFields('deep.admin_user.details.permission_ids', updatePermissions(id, payLoad)));
  };

  render() {
    const { user, userDetails, statuses, formValid, permissionFormValid } = this.props;
    const { relationships, attributes } = user;
    const {
      user_email,
      user_mobile,
      user_status,
      account_locked,
      securityQuestion,
      securityAnswer,
      showDeletePopup
    } = this.state;


    return (
      <LayoutContainer>
        <Form model="deep.admin_user.details"
              validators={{
                '': {
                  communication: (vals) => userDetails.comms_email || userDetails.comms_mobile,
                  account_locked: (vals) => vals.account_locked
                }
              }}
              validateOn="submit"
              className="user-details-form"
              onSubmit={this.onSubmitUser}>
          <Errors className="errors" model="deep.admin_user.details" component={ErrorMessages} />
          <Row>
            <Col lg={6}>
              <UserTitleSelector />

              <UserFirstNameInput />

              <UserLastNameInput />

              <DateOfBirthSelector />
            </Col>

            <Col lg={6}>
              <ControlLabel>Communication preferences*</ControlLabel>
              <Errors
                show={{ touched: true }}
                className="errors"
                model="deep.admin_user.details"
                messages={{ communication: 'You must select at least one communication preference.' }} />
              <br/>
              <Col lg={3}>
                <FormGroup>
                  <Control.checkbox model=".comms_email" component={Checkbox}>email</Control.checkbox>
                </FormGroup>
              </Col>
              <Col lg={9}>
                <FormGroup controlId="email" validationState={user_email}>
                  <Control.text
                    model=".email"
                    type="email"
                    placeholder="Email"
                    disabled={!userDetails.comms_email}
                    component={FormControl}/>

                  <Errors
                    show={{ touched: true, focus: false }}
                    className="errors"
                    model=".email"
                  />
                </FormGroup>
              </Col>
              <Col lg={3}>
                <FormGroup>
                  <Control.checkbox model=".comms_mobile" component={Checkbox}>mobile</Control.checkbox>
                </FormGroup>
              </Col>
              <Col lg={9}>
                <FormGroup controlId="mobile" validationState={user_mobile}>
                  <Control.text
                    model=".mobile"
                    type="tel"
                    placeholder="Mobile"
                    disabled={!userDetails.comms_mobile}
                    component={FormControl}/>

                  <Errors
                    show={{ touched: true, focus: false }}
                    className="errors"
                    model=".mobile"
                  />
                </FormGroup>
              </Col>

              <FormGroup controlId="userStatus" validationState={user_status}>
                <ControlLabel>Status*</ControlLabel>
                <Control.select model=".status"
                                validators={{ required: validators.required(this.updateErrors, 'user_status') }}
                                component={FormControl}
                                componentClass="select">
                  <option value="">Select status...</option>
                  {statuses && Object.keys(statuses).map(item => <option key={item} value={item}>{statuses[item]}</option>)}
                </Control.select>

                <Errors
                  show={{ touched: true, focus: false }}
                  className="errors"
                  model=".status"
                  messages={{ required: 'This field is required' }}
                />
              </FormGroup>

              <FormGroup controlId="userAccountLocked" validationState={account_locked}>
                <div>
                  <ControlLabel>Account locked*</ControlLabel>
                </div>
                <Control.radio model=".account_locked"
                               value="true"
                               validators={{ required: validators.required(this.updateErrors, 'account_locked') }}
                               component={Radio}>Yes</Control.radio>
                <Control.radio model=".account_locked"
                               value="false"
                               validators={{ required: validators.required(this.updateErrors, 'account_locked') }}
                               component={Radio}>No</Control.radio>

                <Errors
                  show={{ touched: true }}
                  className="errors"
                  model=".account_locked"
                  messages={{ required: 'You must set account lock state.' }} />
              </FormGroup>
            </Col>

          </Row>
          <Row>
            <Col lg={6}>
              <FormGroup>
                <ControlLabel>Security question</ControlLabel>
                <FormControl componentClass="select"
                             value={securityQuestion}
                             onChange={(e) => this.setState({securityQuestion: +e.target.value})}>
                  <option value="" disabled>Select a question...</option>
                  {relationships && relationships['security-questions'].data.map(item => {
                    return (<option key={item.id} value={item.id}>{item.name}</option>)
                  })}
                </FormControl>
              </FormGroup>

              <Link to={`/admin/users/${user.id}/details/security-questions`}>
                <Button bsStyle="link" disabled={!checkPermission('update', 'SecurityQuestion')}>
                  Update security questions
                </Button>
              </Link>
            </Col>

            <Col lg={6}>
              <Button className="red-ghost-btn view-answer" onClick={this.showSecurityAnswer}
                      disabled={!securityQuestion}>View</Button>
              <span>{securityAnswer}</span>
            </Col>
            {
              relationships && relationships.outlets.data.length === 0 &&
              <ArrowButton arrow={false}
                           submit={false}
                           color="grey"
                           className="pull-right"
                           permissions={{
                             action: 'destroy',
                             subjectClass: 'User'
                           }}
                           onClick={this.toggleDeletePopup}>Delete user</ArrowButton>
            }
            {
              showDeletePopup &&
              <ConfirmPopup header="Delete user?"
                            onClose={this.handleDeletePopup}>
                <p>Do you really want to delete this user?
                  This operation will redact all personal information on the user record?</p>
              </ConfirmPopup>}
          </Row>
          <Row>
            <Col lg={12}>
              <ArrowButton
                className="pull-right"
                disabled={!formValid}
              >
                Save
              </ArrowButton>
            </Col>
          </Row>
        </Form>
        <hr/>

        {relationships && relationships['staff-permissions'] &&

          <Form model="deep.admin_user.details.staff_permission_ids"
                validateOn="submit"
                className="user-details-form"
                onSubmit={this.onSubmitPermissions}>
            <Errors className="errors" model="deep.admin_user.details.staff_permission_ids"
                    component={ErrorMessages}/>
            <Row>
              <Col lg={12} className="permissions-matrix">
                <Row>
                  <Col lg={8} className="permission-label">
                    <h5>Permissions</h5>
                  </Col>
                  <Col lg={4} className="permission-label">
                    <Col lg={6}>
                      <h5>Yes</h5>
                    </Col>
                    <Col lg={6}>
                      <h5>No</h5>
                    </Col>
                  </Col>
                </Row>

                {relationships['staff-permissions'].data
                  .filter(permission => attributes['has-non-reward-outlet'] || permission.name !== 'Manage staff rewards')
                    .map(item => {
                    return (
                      <Row key={item.id}>
                        <Col lg={8}>
                          <div>{item.name}</div>
                        </Col>
                        <Col lg={4}>
                          <Col lg={6}>
                            <Control.radio model={`.[${item.id}].checked`} value="true" component={Radio}/>
                          </Col>
                          <Col lg={6}>
                            <Control.radio model={`.[${item.id}].checked`} value="false" component={Radio}/>
                          </Col>
                        </Col>
                      </Row>
                    )
                  })
                }
              </Col>
            </Row>
            <Row>
              <ArrowButton color="grey"
                           className="pull-right"
                           disabled={!permissionFormValid}>Save</ArrowButton>
            </Row>
            <hr/>
          </Form>
        }
        {
          user &&
          <IgniteDataTable
            hasAttributes={false}
            data={relationships.outlets.data}
            columns={this.outletColumns}
            actions={this.outletActions}
          />
        }
      </LayoutContainer>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    user: state.users.user,
    statuses: state.users.editorInput.statuses,
    userDetails: state.deep.admin_user.details,
    saveLink: state.users.saveLink,
    formValid: state.deep.forms.admin_user.details.$form.valid,
    permissionFormValid: state.deep.forms.admin_user.details.staff_permission_ids.$form.valid,
  };
};

export default connect(mapStateToProps)(UserDetailsForm);



// WEBPACK FOOTER //
// ./src/components/admin/users/edit/user-details-form.jsx